"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResizedImagePath = void 0;
const ServerPaths_1 = require("./ServerPaths");
function getResizedImagePath(fullImagePath, width = NaN, height = NaN) {
    function isNumber(n) {
        return !isNaN(parseFloat(n)) && !isNaN(n - 0);
    }
    //dont add query string if no image path
    if (!fullImagePath)
        return fullImagePath;
    //replace the normal upload path with the resized path, see LincdServer for more info how this works
    return (fullImagePath.replace(ServerPaths_1.publicUploadPath + '/', ServerPaths_1.publishResizedImagePath + '/') +
        '?' +
        (isNumber(width) ? 'w=' + width : '') +
        (isNumber(height) ? (isNumber(width) ? '&' : '') + 'h=' + height : ''));
}
exports.getResizedImagePath = getResizedImagePath;
//# sourceMappingURL=ImageResize.js.map